module.exports = __webpack_public_path__ + "img/tran_1kl.7a62a0a5.jpg";